export default "__VITE_ASSET__C7l8T5Mj__"